import OptionGroupForm from '../components/OptionGroupForm'

const CreateOptionGroupPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Create Option Group</h1>
        <p className="mt-1 text-sm text-gray-500">
          Create a new option group for product customization
        </p>
      </div>
      
      <OptionGroupForm />
    </div>
  )
}

export default CreateOptionGroupPage
